import { useDispatch } from 'react-redux';
import { setSelectedBrandId } from '../Redux/features/auth/authSlice';
import apiSlice from '../Redux/api/apiSlice';

export const useBrandSelector = () => {
  const dispatch = useDispatch();

  const switchBrand = (brandId) => {
    // Actualizar la marca seleccionada
    dispatch(setSelectedBrandId(brandId));
    
    // Invalidar todos los tags relevantes para refrescar los datos
    dispatch(apiSlice.util.invalidateTags([
      'BrandData',
      'Challenges', 
      'Briefings',
      'Collabs',
      'UserData',
      'UsersData',
      'UserInvitations',
      'BrandDataOverview'
    ]));
  };

  const setDefaultBrand = (brandId) => {
    // Solo establecer la marca sin invalidar datos (para uso inicial)
    dispatch(setSelectedBrandId(brandId));
  };

  return { switchBrand, setDefaultBrand };
}; 